/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CardExpirationState = 'EXPIRED' | 'NEARING' | 'OK';

export type CardType =
  | 'AMERICAN_EXPRESS'
  | 'AMEX'
  | 'DISCOVER'
  | 'MASTER_CARD'
  | 'UNSUPPORTED'
  | 'VISA';

export type SavedPaymentMethodsQueryVariables = Exact<{ [key: string]: never }>;

export type SavedPaymentMethodsQuery = {
  readonly paymentMethodCards: ReadonlyArray<
    | {
        readonly __typename: 'PaymentMethodCard';
        readonly id: string;
        readonly description: string | null;
        readonly nickname: string | null;
        readonly isDefault: boolean;
        readonly cardType: Types.CardType;
        readonly expirationState: Types.CardExpirationState;
      }
    | Record<PropertyKey, never>
  >;
};

export const SavedPaymentMethodsDocument = gql`
  query SavedPaymentMethods {
    paymentMethodCards {
      ... on PaymentMethodCard {
        __typename
        id
        description
        nickname
        isDefault
        cardType
        expirationState
      }
    }
  }
`;

export function useSavedPaymentMethodsQuery(
  options?: Omit<Urql.UseQueryArgs<SavedPaymentMethodsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SavedPaymentMethodsQuery, SavedPaymentMethodsQueryVariables>({
    query: SavedPaymentMethodsDocument,
    ...options,
  });
}
